import { NgClass, CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AgenxButtonComponent } from '../../atoms/button/button.component';
import { AgenxAlertComponent } from '../../atoms/alert/alert.component';
import { AgenxCircleButtonComponent } from '../../atoms/circle-button/circle-button.component';
import { CardContent, SpecialGauge } from '../../../../interfaces/gauging.interface';
import { LimitCharsPipe } from "../../../../pipes/limit-chars.pipe";
import { OfflineService } from '../../../../services/offline.service';
import { ToastService } from '../../../../services/toast.service';
import { GaugingService } from '../../../../services/gauging.service';
import { Router } from '@angular/router';
import {
  addDays,
  dateTimeToString,
  stringToDateTime,
} from '../../../../utils/date-functions';

@Component({
  selector: 'agenx-card-gauge',
  standalone: true,
  templateUrl: './card-gauge.component.html',
  styleUrl: './card-gauge.component.scss',
  imports: [
    NgClass,
    AgenxButtonComponent,
    AgenxCircleButtonComponent,
    AgenxAlertComponent,
    LimitCharsPipe,
    CommonModule,
  ],
})
export class AgenxCardGaugeComponent implements OnChanges {
  /**
   * Card button text
   *
   * @type {string}
   * @memberof AgenxCardSubComponent
   */
  @Input() buttonCardText: string = '';

  /**
   * Type of the card (orange or blue)
   *
   * @type {('orange' | 'blue')}
   * @memberof AgenxCardSubComponent
   */
  @Input() typeCard: 'orange' | 'blue' = 'blue';

  /**
   * info of the card
   *
   * @type {CardContent}
   * @memberof AgenxAuthComponent
   */
  @Input() card_info!: CardContent;

  /**
   * info of the card
   *
   * @type {number}
   * @memberof AgenxAuthComponent
   */
  @Input() index!: number;
  @Input() modelCard: 'done' | 'pend' | 'simple' | 'search' = 'pend';

  /**
   * Event emitter to emit the selected card content
   *
   * @memberof AgenxCardSubComponent
   */
  @Output() selectedCardSub = new EventEmitter<{
    cardSubButtonType: string;
    card_info: CardContent;
  }>();

  icon_create_src = '';
  icon_download_src = '';
  icon_resend_src = '';
  icon_delete_src = '';
  icon_edit_src = '';
  toast: any = null;
  no_internet = false;
  unblock_date: string | null = null;

  constructor(
    private gaugingSrv: GaugingService,
    public offlineSrv: OfflineService,
    private toastSrv: ToastService,
    private router: Router,
  ) {}

  /**
   * Sets `unblock_date` when the subscriber has the gauging sheet disabled
   * (today <= gauging_block_date). The date shown is the day after the block date.
   */
  ngOnChanges(): void {
    const block_date = this.card_info?.subscriber?.gauging_block_date;
    if (!block_date) {
      this.unblock_date = null;
      return;
    }
    const unblock = addDays(stringToDateTime(block_date, 'DD/MM/YYYY')!, 1);
    this.unblock_date =
      new Date() < unblock ? dateTimeToString(unblock, 'DD/MM/YYYY') : null;
  }

  ngOnInit(): void {
    this.offlineSrv.onlineStatus$.subscribe((isOnline: boolean) => {
      this.no_internet = !isOnline;
    });
    this.icon_create_src = this.offlineSrv.loadAssetInLocal(
      'header-icon-plus.svg',
    );
    this.icon_download_src =
      this.offlineSrv.loadAssetInLocal('Icon_Download.svg');
    this.icon_resend_src = this.offlineSrv.loadAssetInLocal('Icon_Resend.svg');
    this.icon_delete_src = this.offlineSrv.loadAssetInLocal('Icon_Delete.svg');
    this.icon_edit_src = this.offlineSrv.loadAssetInLocal('Icon_Edit.svg');
  }

  clickOnCardsub(buttonName: string) {
    this.selectedCardSub.emit({
      cardSubButtonType: buttonName,
      card_info: this.card_info,
    });
  }

  getAddress(): string {
    let text = this.card_info.subscriber
      ? this.card_info.subscriber.address
      : this.card_info.client?.address;
    return text ? text : '---';
  }

  onCreateOrdinary(): void {
    let subsc = this.card_info.subscriber!;
    let values_content = [
      { title: 'Niud:', value: subsc.niud },
      { title: 'Nombre:', value: subsc.name },
      { title: 'Dirección:', value: subsc.address },
      { title: 'Contrato:', value: subsc.contract },
      { title: 'Estrato:', value: `${subsc.stratum}` },
    ];
    let aux_content = {
      valuesContent: values_content,
      id: subsc.id,
      email: subsc.email,
      stratum_id: subsc.stratum_id,
      identification: subsc.identification,
      gaugin_code: subsc.gaugin_code,
      gauging: subsc.gauging,
    };
    // if (subsc.rate_type !== 'Aforo') {
    //   aux_content['alertInfo'] = {
    //     alertText: 'Este suscriptor no cuenta con tipo tarifa de aforo.',
    //     alertType: 'warning',
    //   };
    // }
    this.offlineSrv.saveToLocal('subs_data', aux_content);
    this.router.navigateByUrl('/create_edit');
  }

  onCreateSpecial() {
    if (!this.card_info.hasOwnProperty('metadata')) {
      this.card_info['metadata'] = { registers: [] };
    }
    this.offlineSrv.saveToLocal('special_data', this.card_info);
    this.router.navigateByUrl('/create_special');
  }

  onDonwnload() {
    this.toast = this.toastSrv.load('Descargando reporte');
    this.gaugingSrv.downloadVoucher(this.card_info.id!).subscribe({
      next: (result: any) => {
        this.toast.close();
        window.open(result.url, '_blank');
      },
      error: (error: { error: { detailed: string } }) => {
        let message = error.error.hasOwnProperty('detailed')
          ? error.error.detailed
          : 'No se pudo descargar el reporte.';
        this.no_internet &&
          (message += ' No cuenta con una conexión estable a internet.');
        this.toastSrv.error(message);
      },
    });
  }

  onDelete(): void {}

  onEdit(): void {}

  onResend() {
    this.toast = this.toastSrv.load('Enviando reporte');
    this.gaugingSrv.resendVoucher(this.card_info.id!).subscribe({
      next: (result: any) => {
        this.toast.close();
        this.toastSrv.success('Se ha enviado el reporte con exito');
      },
      error: (error: { error: { detailed: string } }) => {
        let message = error.error.hasOwnProperty('detailed')
          ? error.error.detailed
          : 'No se pudo reenviar el reporte.';
        this.no_internet &&
          (message += ' No cuenta con una conexión estable a internet.');
        this.toastSrv.error(message);
      },
    });
  }
}
